import { SparklesIcon, XMarkIcon } from "@heroicons/react/16/solid";
import { useStore } from "@nanostores/react";
import { clsx } from "clsx";
import { ReactElement, useEffect } from "react";

import { AI_ASSISTANT_WIDTH } from "../../constants/layout.ts";
import { ensureConversationForSession } from "../../stores/conversation.ts";
import { $router } from "../../stores/router.ts";
import { Button } from "../catalyst/Button.tsx";
import { Heading } from "../catalyst/Heading.tsx";
import { AIAssistantChat } from "./AIAssistantChat.tsx";

export interface AIAssistantSidebarProps {
  initialMessage: ReactElement;
  isOpen: boolean;
  onClose: () => void;
  placeholder: string;
  reloadMessages?: () => void;
}

export const AIAssistantSidebar = ({
  initialMessage,
  isOpen,
  onClose,
  placeholder,
}: AIAssistantSidebarProps): null | ReactElement => {
  const router = useStore($router);

  const route = router?.route || "unknown";
  const graphId = router?.route === "graph" ? router.params.id : undefined;

  useEffect(() => {
    if (isOpen && graphId) {
      void ensureConversationForSession(graphId);
    }
  }, [isOpen, graphId]);

  if (!isOpen) return null;

  return (
    <div
      className={clsx(
        "fixed top-0 z-50 flex h-full w-96 flex-col border-l border-zinc-700 bg-zinc-900 shadow-xl transition-transform duration-300 ease-in-out",
        isOpen ? "right-0" : "",
      )}
      style={{
        right: isOpen ? 0 : -AI_ASSISTANT_WIDTH,
      }}
    >
      <AIAssistantChat
        attachments="aiContext"
        emptyState={initialMessage}
        enabled={isOpen}
        getSendContext={() => ({
          currentRoute: route,
          graphId: graphId,
        })}
        header={
          <div className="flex items-center justify-between border-b border-zinc-700 p-4">
            <div className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-lg">
                <SparklesIcon className="h-4 w-4 text-white" />
              </div>
              <Heading level={2}>Miru Copilot</Heading>
            </div>

            <Button color="zinc" onClick={onClose}>
              <XMarkIcon className="h-4 w-4" />
            </Button>
          </div>
        }
        placeholder={placeholder}
        sessionId={graphId ?? null}
        size="small"
      />
    </div>
  );
};
